import { useLocale } from '@/i18n/locale-context';
import { ButtonLink, EmptyState } from '@/components/ui';

/**
 * The 404 page. It renders inside the shell like any other route, because a reader who
 * mistyped a URL should land somewhere navigable rather than on a dead end — and because
 * the server answers 404 for this path (`resolveMeta`), so the status code is right
 * whatever the page looks like.
 */
export default function NotFound() {
  const { t, path } = useLocale();

  return (
    <div className="px-gutter py-16">
      <EmptyState
        title={t('error.notFoundTitle')}
        body={t('error.notFoundBody')}
        action={
          <ButtonLink to={path()} size="sm">
            {t('nav.home')}
          </ButtonLink>
        }
      />
    </div>
  );
}
